export const environment = {
  production: false,
  apiUrl: 'https://tdev1.onfield.live',
};

// see environment.ts for more info
import 'zone.js/dist/zone-error';
